import { render, staticRenderFns } from "./AzPersonsMappingsReadOnlyPanel.vue?vue&type=template&id=c9525c76"
import script from "./AzPersonsMappingsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./AzPersonsMappingsReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports